import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, ParagraphMomento } from "@tumomento/ui";
import { useDimensions } from "@/hooks/useDimensions";
//import { useAgentRegistrationLogic } from "@/hooks/useAgentRegistrationLogic";
import {
  classNamesList,
  goToAgentProfile,
  goToUserProfile,
  goToWizardQuote,
} from "@/utils/components";
import "./Navbar.scss";
import { SearchOption } from "@/components/business/SearchOption";

const URL_HOST = "https://www.tumomento.com";

const useNavbarLogic = () => {
  //const router = useRouter();
  const { isMobile, width } = useDimensions();
  //const { handleOpenModalAgentRegistration } = useAgentRegistrationLogic();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [showCTAButton, setShowCTAButton] = useState(false);
  const [isFixedActive, setIsFixedActive] = useState(false);

  interface INavbarItem {
    id: string;
    title: string;
    href: string;
  }

  const NavbarItems: INavbarItem[] = [
    {
      id: "NavIncidents",
      title: "Siniestros",
      href: `${URL_HOST}/siniestros`,
    },
    {
      id: "NavApp",
      title: "App",
      href: `${URL_HOST}/app`,
    },
    {
      id: "NavAboutUs",
      title: "Quiénes somos",
      href: `${URL_HOST}/quienes-somos`,
    },
    {
      id: "NavAgents",
      title: "Agentes",
      href: `${URL_HOST}/agentes`,
    },
  ];

  const handleScroll = (event: any) => {
    setShowCTAButton(event.currentTarget.pageYOffset > 72);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isAgentPageActive = false;

  const LinkUserProfile = () => {
    const loginUrl = isAgentPageActive ? goToAgentProfile : goToUserProfile;
    const loginText = isAgentPageActive
      ? "Login portal de agentes"
      : "Mi perfil";
    return (
      <ParagraphMomento
        typography="body-m"
        className={`flex align-center cursor my-profile ${
          isMobile ? "py-3 px-6" : "pe-8"
        }`}
        onClick={loginUrl}
      >
        {!isMobile && (
          <img
            src="/images/drop-green.svg"
            height={13}
            width={14}
            alt={"Momento"}
            className="me-1"
          />
        )}
        {loginText}
      </ParagraphMomento>
    );
  };

  const ButtonQuotation = ({ isMobile = false }) => {
    return (
      <Button
        className={`button-quotation ${
          showCTAButton || (isFixedActive && "-activebtn")
        }`}
        onClick={() => goToWizardQuote()}
        style={isMobile ? { width: "100%" } : {}}
      >
        Cotizar mi seguro
      </Button>
    );
  };

  const NavbarMenuDesktop = () => {
    return (
      <div
        className={classNamesList(
          "flex center-content-h justify-between",
          "NavbarMenu showDesktop"
        )}
      >
        <ul
          className={classNamesList("flex center-content-h", "NavbarMenuLeft")}
        >
          {NavbarItems.map(({ id, href, title }) => (
            <li
              key={id}
              className={classNamesList(id === "NavAgents" ? "AgentItem" : "")}
            >
              <a href={href} className="w100">
                <ParagraphMomento
                  typography="body-m"
                  //color={router.pathname === href ? "green3" : "content2"}
                  align={isMobile ? "left" : "center"}
                  className={`li-items ${
                    (showCTAButton || isFixedActive) && "-activeitem"
                  }`}
                >
                  {title}
                </ParagraphMomento>
                {/* {router.pathname === href && (
                  <hr className={styles.ItemActive} />
                )} */}
              </a>
            </li>
          ))}
          <SearchOption invertColors={showCTAButton || isFixedActive} />
        </ul>
        <div
          className={classNamesList("flex center-content-h", "NavbarMenuRigth")}
        >
          {/* <LinkUserProfile /> */}
          <ButtonQuotation />
        </div>
      </div>
    );
  };

  const NavbarMenuMobile = () => {
    return (
      <div className={classNamesList("flex col justify-between", "NavbarMenu")}>
        <ul
          className={classNamesList(
            `flex ${isMobile ? "col" : "row center-content-h"}`,
            "NavbarMenuLeft"
          )}
        >
          {NavbarItems.map(({ id, href, title }) => (
            <li key={id}>
              <a
                href={href}
                className={`w100`}
                onClick={() => setOpenDrawer(false)}
              >
                <ParagraphMomento
                  typography="body-m"
                  //color={router.pathname === href ? "green3" : "content2"}
                  align={isMobile ? "left" : "center"}
                  className="py-3 px-6"
                  style={{
                    fontSize: "16px",
                    color: "#818181",
                  }}
                >
                  {title}
                </ParagraphMomento>
              </a>
            </li>
          ))}
        </ul>
        <div style={{ padding: "0 20px", width: "100%" }}>
          <ButtonQuotation isMobile={true} />
        </div>
      </div>
    );
  };

  return {
    //router,
    isMobile,
    NavbarItems,
    NavbarMenuDesktop,
    NavbarMenuMobile,
    openDrawer,
    setOpenDrawer,
    isAgentPageActive,
    showCTAButton,
    setShowCTAButton,
    isFixedActive,
    setIsFixedActive,
  };
};

export default useNavbarLogic;
